/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Web_Scraping_TitleInputs */

const en_svc_web_scraping_title = /** @type {(inputs: Svc_Web_Scraping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web Scraping & Data Extraction`)
};

const ar_svc_web_scraping_title = /** @type {(inputs: Svc_Web_Scraping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استخراج بيانات الويب`)
};

const bn_svc_web_scraping_title = /** @type {(inputs: Svc_Web_Scraping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওয়েব স্ক্র্যাপিং ও ডেটা এক্সট্রাকশন`)
};

const de_svc_web_scraping_title = /** @type {(inputs: Svc_Web_Scraping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web Scraping und Datenextraktion`)
};

const es_svc_web_scraping_title = /** @type {(inputs: Svc_Web_Scraping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web scraping y extracción de datos`)
};

const fr_svc_web_scraping_title = /** @type {(inputs: Svc_Web_Scraping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scraping Web et extraction de données`)
};

const pt_svc_web_scraping_title = /** @type {(inputs: Svc_Web_Scraping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web Scraping e extração de dados`)
};

const zh_svc_web_scraping_title = /** @type {(inputs: Svc_Web_Scraping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`网页抓取和数据提取`)
};

const tr_svc_web_scraping_title = /** @type {(inputs: Svc_Web_Scraping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web Kazıma ve Veri Çıkarma`)
};

const ru_svc_web_scraping_title = /** @type {(inputs: Svc_Web_Scraping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Парсинг веб-страниц и извлечение данных`)
};

const pl_svc_web_scraping_title = /** @type {(inputs: Svc_Web_Scraping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeszukiwanie sieci i ekstrakcja danych`)
};

/**
* | output |
* | --- |
* | "Web Scraping & Data Extraction" |
*
* @param {Svc_Web_Scraping_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_web_scraping_title = /** @type {((inputs?: Svc_Web_Scraping_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Web_Scraping_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_web_scraping_title(inputs)
	if (locale === "bn") return bn_svc_web_scraping_title(inputs)
	if (locale === "de") return de_svc_web_scraping_title(inputs)
	if (locale === "es") return es_svc_web_scraping_title(inputs)
	if (locale === "fr") return fr_svc_web_scraping_title(inputs)
	if (locale === "pt") return pt_svc_web_scraping_title(inputs)
	if (locale === "zh") return zh_svc_web_scraping_title(inputs)
	if (locale === "tr") return tr_svc_web_scraping_title(inputs)
	if (locale === "ru") return ru_svc_web_scraping_title(inputs)
	if (locale === "pl") return pl_svc_web_scraping_title(inputs)
	return en_svc_web_scraping_title(inputs)
});
export { svc_web_scraping_title as "svc_web-scraping_title" }